import { BubbleSeriesChart } from '@/common/dashboard/charts/BubbleSeriesChart';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';

export const ChbkPrioritizationBubbleChart = ({ selectedPeriod, selectedDistCusts = [] }) => {

    const rsrc = useRsrc();
    const [data, setData] = useState();

    const { navigateTo } = useNavState();

    const navigateToDetail = (seriesName, point) => {
        const navState = {
            mode: Mode.DETAIL,
            entityId: point.entityId,
        };

        navigateTo('sc/indir-sale', navState);
    }

    useEffect(() => {
        if (!selectedPeriod?.id) {
            return null;
        }

        const distCustIds = selectedDistCusts.map(distCust => distCust.id);
        const reqParam = {
            periodId: selectedPeriod?.id,
            distCustIds
        }

        rsrc.data('sc', 'CHBK_PRIORITIZATION_BUBBLE_CHART_DATA_PLUGIN', reqParam).then(data => {
            setData(data);
        });
    }, [selectedPeriod, selectedDistCusts]);

    const dollarFormatter = (dataPointValue) => {
        return '$' + Number(dataPointValue).toLocaleString();
    }

    const tooltipHeaderFormatter = (dataPoint) => {
        return `${dataPoint.code}<br>Status: ${dataPoint.label}`;
    };

    return (
        <BubbleSeriesChart
            xLabel="Days Since Received"
            yLabel="Disputed Amount"
            zLabel="Due Amount"
            yTooltipValueFormatter={dollarFormatter}
            zTooltipValueFormatter={dollarFormatter}
            tooltipHeaderFormatter={tooltipHeaderFormatter}
            onClick={navigateToDetail}
            data={data}
        />
    );
};
